
module.exports = {
	Roles: [
	    {
	        code: 'adm',
	        name: 'Admin'
	    }, {
	        code: 'ins',
	        name: 'Kontrollstelle'
	    }, {
	        code: 'aut',
	        name: 'Behörde'
	    }, {
	        code: 'sup',
	        name: 'Anbieter*in'
	    }, {
	        code: 'agr',
	        name: 'Landwirt*in'
	    }, {
	        code: 'aso',
	        name: 'Verband'
	    }
	]
}
